export enum IntensityEnum {
  Intensive = 1,
  SemiIntensive = 2,
  Relaxed = 3,
}
